import {useEffect, useCallback} from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {useTheme} from '@mui/styles'

import {connect, useDispatch} from 'react-redux'
import {userAPI} from '../../apis'
import {useIsMounted} from '../../hooks'
import {showAlert} from '../../actions'


import Button from '@mui/material/Button'



const styles = {
  root: css`
    height: 100%;
    display: flex;
    flex-direction: column;
  `,
  text: theme => css`
    margin-top: 30px;
    font-size: 15px;
    font-weight: 500;
    text-align: center;
    color: #828282;
    b { color: ${theme.palette.pink._500}; font-weight: 600 }
  `,
  button: css`
    margin-top: 40px;
    height: 50px;
    width: 100%;
    box-shadow: none;
    &:hover { box-shadow: none; }
  `,
}




const EmailConfirmationNotice = ({type, nextStep, showAlert, callback}) => {

  const isMounted = useIsMounted()

  const dispatch = useDispatch()

  const theme = useTheme()


  const checkAndContinue = useCallback(async () => {
    try {
      const resp = await userAPI.getAuthStatus()
      const user = resp.data.data
      if (!user.id) throw new Error('Invalid user response')

      dispatch({type: 'SET_USER', payload: user})

      if (type === 'user') {
        dispatch({type: 'AUTH_STATUS_SUCCESS'})
        callback?.()
      } else if (isMounted.current) {
        nextStep()
      }
    } catch (err) {
      showAlert(err.apiMessage(), 'error')
    }
  }, [dispatch, type, nextStep, callback, isMounted, showAlert])



  useEffect(() => {
    window.addEventListener('focus', checkAndContinue)
    return () => window.removeEventListener('focus', checkAndContinue)
  }, [checkAndContinue])



  // 3) Single unified instruction text
  const instruction = `
    Check your inbox for an email from registration@ckord.com and follow the directions to confirm your email.
    ${
      type === 'user'
        ? 'Then come back here and tap the button below.'
        : `After you confirm, you'll be forwarded to the final "${type}" account setup step.`
    }
  `


  return (
    <div css={styles.root}>
      <p css={styles.text(theme)}>
        {instruction}
      </p>
      <Button
        css={styles.button}
        variant='contained'
        color='primary'
        onClick={checkAndContinue}
      >
        Let’s Rock and Roll
      </Button>
    </div>
  )
}


export default connect(null, {showAlert})(EmailConfirmationNotice)



